

<template>
  <!-- Subscribe Area Start -->
  <section class="subscribe_area">
    <img src="../assets/img/shape_10.png" alt="shape" class="shape_10">
    <img src="../assets/img/shape_11.png" alt="shape" class="shape_11">
    <img src="../assets/img/shape_12.png" alt="shape" class="shape_12">
    <img src="../assets/img/shape_13.png" alt="shape" class="shape_13">
    <img src="../assets/img/shape_14.png" alt="shape" class="shape_14">
    <img src="../assets/img/shape_15.png" alt="shape" class="shape_15">
    <img src="../assets/img/shape_16.png" alt="shape" class="shape_16">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="subscribe_inn">
            <div class="site_heading">
              <h3 class="sub_title">Don’t miss</h3>
              <h2 class="section_title">Subsribe To Newsletter</h2>
            </div>
            <div class="subscribe_box">
              <form>
                <input type="email" placeholder="Enter your E-mail"/>
                <button type="submit">Subscribe</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Subscribe Area End -->
</template>
<script>
export default {
  name: 'SubscribeArea'
}
</script>



// WEBPACK FOOTER //
// src/components/SubscribeArea.vue